// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PopoverHeader-base__GuxD7{position:sticky;top:var(--size-0);z-index:var(--z-index-drawer);display:flex;flex-direction:column;width:var(--size-full)}.PopoverHeader-innerContainer__jqzOe{display:flex;align-items:center;width:var(--size-full);min-height:var(--size-14);padding:var(--size-3) var(--size-4)}.PopoverHeader-actionsSlot___Iodx{display:flex;flex-shrink:0;gap:var(--size-2);align-items:center;padding-left:var(--size-3)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "PopoverHeader-base__GuxD7",
	"innerContainer": "PopoverHeader-innerContainer__jqzOe",
	"actionsSlot": "PopoverHeader-actionsSlot___Iodx"
};
export default ___CSS_LOADER_EXPORT___;
